import Footer from '../../components/Footer';
import Header from '../../components/Header/Header';
import { HomeWrapper } from '../GamePage/GamePage.styled';
import { Wrapper, StyledTitle, StyledProfileBanner, StyledProfileInfo, StyledProfileAvatarTitle, StyledProfileEditTitle, StyledProfileInfoTop, StyledProfileInfoBottom, StyledProfileImage, StyledProfileName, StyledProfilePeriod, StyledAddressTitle } from './ProfilePage.styled';
import AccountBannerImage from "../../assets/images/account-banner.png"
import ProfileImage from "../../assets/images/profile.png"
import { Info } from './Info/Info';
import { useContext, useEffect, useState } from 'react';
import { PlayerContext } from '../../contexts/playerContext';
import Input from '../../components/Input/Input';
import AvatarSelector from './AvatarSelector/AvatarSelector';
import Button from '../../components/Button/Button';
import { updateUserInfo } from '../../utils/updateUserInfo';
import { getPlayerLeaderBoard } from '../../utils/getPlayerLeaderBoard';

export const ProfilePage: React.FC = () => {
  const playerContext = useContext(PlayerContext);

  const [name, setName] = useState<string>(playerContext == undefined ? "" : playerContext.playerName);
  const [avatar, setAvatar] = useState<File | null>(null);
  const [createdAt, setCreatedAt] = useState<string>("---");
  const [leaderboard, setLeaderboard] = useState<any>(null);

  const handleUpdateName = (e: any) => {
    setName(e.target.value);
  }

  useEffect(() => {
    setCreatedAt(`Member since ${playerContext?.createdAt.toLocaleString('en-US', { month: 'long' })} ${playerContext?.createdAt.getFullYear()}`)
  })

  useEffect(() => {
    if (!playerContext || !playerContext?.wallet) {
      return;
    }

    setName(playerContext?.playerName);

    const handleGetPlayerLeaderboard = async () => {
      const res = await getPlayerLeaderBoard(playerContext?.wallet.publicKey?.toString());
      if (res == undefined) return;
      if (res.status) {
        setLeaderboard(res.leaderboard);
      }
    }

    handleGetPlayerLeaderboard();
  }, [playerContext])

  const handleSubmit = async () => {
    if (playerContext == undefined) {
      return;
    }

    const res = await updateUserInfo(playerContext?.playerId, name, avatar);

    if (res == null) {
      return;
    }

    playerContext.playerNameHandler(res.name);
    if (res.avatarPath) {
      playerContext.playerAvatarHandler(res.avatarPath);
    }
  };

  const getOrdinalSuffix = (number: number) => {
    const suffixes = ["th", "st", "nd", "rd"];
    const value = number % 100;

    if (value >= 11 && value <= 13) {
      return number + suffixes[0]; // Special case for 11th, 12th, 13th
    }
    return number + (suffixes[number % 10] || suffixes[0]);
  }

  const formatWithCommas = (number: number) => {
    return new Intl.NumberFormat('en-US').format(number);
  }

  return (
    <HomeWrapper>
      <Header />
      <Wrapper>
        <StyledTitle>Account Information</StyledTitle>
        <StyledProfileBanner>
          <img src={AccountBannerImage} alt="account banner" />
          <StyledProfileInfo>
            <StyledProfileInfoTop>
              <StyledProfileImage src={playerContext?.avatar == "" ? ProfileImage : `${process.env.REACT_APP_API_ENDPOINT}${playerContext?.avatar}`} crossOrigin="anonymous" alt="profile image" />
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '20px' }}>
                <StyledProfileName>{playerContext?.playerName}</StyledProfileName>
                <StyledProfilePeriod>{createdAt}</StyledProfilePeriod>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '10px', flexWrap: 'wrap' }}>
                <StyledAddressTitle>Address:</StyledAddressTitle>
                <StyledProfilePeriod>{playerContext?.wallet.publicKey?.toString()}</StyledProfilePeriod>
              </div>
            </StyledProfileInfoTop>
            <StyledProfileInfoBottom>
              <Info title="Place(Last 24h)" content={leaderboard == null || leaderboard.rank == -1 ? "---" : getOrdinalSuffix(leaderboard.rank)} />
              <Info title="Hands Played" content={leaderboard == null ? "---" : formatWithCommas(leaderboard.hands_played)} />
              <Info title="Hands Won" content={leaderboard == null ? "---" : formatWithCommas(leaderboard.hands_won)} />
              <Info title="Win Percentage" content={leaderboard == null ? "---" : `${(leaderboard.hands_won / leaderboard.hands_played * 100).toFixed(1)}%`} />
              <Info title="Total Earn" content={`${leaderboard == null ? "---" : formatWithCommas(leaderboard.tokens_won / 1000)} sol`} />
              <Info title="Overall Rank" content={leaderboard == null || leaderboard.rank == -1 ? "---" : getOrdinalSuffix(leaderboard.overallRank)} />
            </StyledProfileInfoBottom>
          </StyledProfileInfo>
        </StyledProfileBanner>
        <StyledTitle>Update Information</StyledTitle>
        <StyledProfileEditTitle>User Name</StyledProfileEditTitle>
        <Input width={'250px'} value={name} event={handleUpdateName} />
        <StyledProfileAvatarTitle>Avatar</StyledProfileAvatarTitle>
        <AvatarSelector setAvatar={setAvatar} round={true} />
        <Button padding="20px" textSize="12px" text="Save" image={null} size="small" event={handleSubmit} />
      </Wrapper>
      <Footer />
    </HomeWrapper>
  );
};